module.exports = {
      id: "plus-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }